import { Table, Button } from "react-bootstrap";
import SelectStudentTableRow from "./SelectStudentTableRow";

const SelectStudentTable = ({
  students,
  type,
  checkedStudents,
  toggleStudentCheck,
  toggleSelectAll,
  addStudents,
  removeStudent,
  observerTarget,
  isLoadingMore,
  hasMore,
}) => {
  const isAllSelected =
    type === "select" &&
    students.length > 0 &&
    checkedStudents?.length === students.length;

  return (
    <div className="custom-table-container">
      <div className="custom-table-wrapper select-student-table-scroll">
        <Table hover className="custom-table">
          <thead className="custom-table-head">
            <tr style={{ maxHeight: "54px", height: "54px" }}>
              <th colSpan="2" style={{ color: "#6B6B6B", fontSize: "16px" }}>
                {type === "select" ? "Students" : ""}
              </th>
              <th>
                {type === "select" && (
                  <div className="">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={toggleSelectAll}
                      id="selectAll"
                      style={{ width: "1.2rem", height: "1.2rem" }}
                    />
                  </div>
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {(!students && !isLoadingMore) ||
            (students.length === 0 && !isLoadingMore) ? (
              <tr>
                <td colSpan="3" style={{ textAlign: "center" }}>
                  {type === "select"
                    ? "No more students"
                    : "Please select students to create a class"}
                </td>
              </tr>
            ) : (
              <>
                {students.map((student) => (
                  <SelectStudentTableRow
                    key={student.id}
                    student={student}
                    type={type}
                    isChecked={checkedStudents?.includes(student.id)}
                    toggleStudentCheck={toggleStudentCheck}
                    removeStudent={removeStudent}
                  />
                ))}
                {/* Infinite scroll observer target */}
                {type === "select" && hasMore && (
                  <tr>
                    <td
                      colSpan="3"
                      ref={observerTarget}
                      style={{ height: "1px", padding: 0 }}
                    >
                      {isLoadingMore && (
                        <div className="text-center py-2">
                          <div
                            className="spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </Table>
      </div>

      {/* Add Students Button */}
      {type === "select" && (
        <div className="add-students-button-wrapper">
          <Button
            variant="dark"
            onClick={addStudents}
            disabled={!checkedStudents || checkedStudents.length === 0}
            className="add-students-button"
          >
            Add Students ({checkedStudents?.length || 0})
          </Button>
        </div>
      )}
    </div>
  );
};

export default SelectStudentTable;
